const fetchAs = require("./fetchAs");

/**
 * Fetch video attributes from a media relationship data
 * @param rel: object with id: uuid and type: media--bundle
 */
module.exports = async function fetchVideo(rel, dispatch = null) {
	let type = rel.type.split("--");
	let video_endpoint = `${type[0]}/${type[1]}/${rel.id}`;
	video_endpoint += `?include=thumbnail`;
	if (type[1] === "video") {
		video_endpoint += `,field_media_video_file`;
	}

	let _video = await fetchAs({ endpoint: video_endpoint, dispatch });
	if (_video && _video.data && _video.data.attributes) {
		let thumbnail_rel = _video.included
			? _video.included.find((item) => item.attributes.filemime.includes("image"))
			: null;

		let url;

		const thumbnail_src = thumbnail_rel?.attributes?.image_style_uri?.crop_thumbnail
			? thumbnail_rel?.attributes?.image_style_uri?.crop_thumbnail
			: `${process.env.GATSBY_BACKEND_URL}${thumbnail_rel?.attributes?.uri?.url || ""}`;

		const thumbnail = thumbnail_rel
			? {
					src: thumbnail_src,
					alt: _video.data.attributes.name,
			  }
			: { src: "/default.jpg", alt: "" };

		if (type[1] === "video") {
			let video_rel = _video.included
				? _video.included.find((item) => item.attributes.filemime.includes("video"))
				: null;
			if (video_rel) {
				url = `${process.env.GATSBY_BACKEND_URL}${video_rel.attributes.uri.url}`;
			}
		} else if (type[1] === "remote_video") {
			url = _video.data.attributes.field_media_oembed_video;
		}

		if (url) {
			return {
				thumbnail,
				url,
			};
		}
	}

	return null;
};
